import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getTemplatesByOrganization, ScriptTemplate } from './scripts';
import { useError } from '@src/contexts/ErrorContext';

export const useCanonicalScriptsByOrg = (organizationId: string) => {
  const { setError } = useError();

  const query = useQuery<ScriptTemplate[]>({
    queryKey: ['canonical-templates-by-org', organizationId],
    queryFn: async () => {
      const templates = await getTemplatesByOrganization(organizationId);
      return Array.isArray(templates) ? templates : [];
    },
    enabled: !!organizationId,
  });

  useEffect(() => {
    if (!query.isError) return;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const error = query.error as any;
    setError({
      title: 'Erro ao carregar scripts',
      message: error?.response?.data?.message || error?.message || 'Não foi possível carregar os scripts',
      statusCode: error?.response?.status,
    });
  }, [query.isError, query.error, setError]);

  return query;
};
